module.exports = __webpack_public_path__ + "media/images/states/tx-red-a0a621d4a046cb3b5e07850e56d0ea3d.png";